export const AUTHENTICATION_TOKEN = 'authenticationToken';
export const LOGGED_IN = 'loggedIn';
export const ACTIVE_COMMUNITY_ID = 'active-community-id';
export const REQUEST_PASSWORD_UPDATE = 'requestPasswordUpdate';
export const REGISTRATION_COMPLETED = 'registrationCompleted';
export const REDIRECT_TO_PAGE = 'redirectToPage';
export const ROOM_INVITATION_TOKEN = 'roomInvitationToken';
export const PAPERWORK_TOKEN = 'paperworkToken';
export const KICKED_TO_LOGIN = '_kicked_to_login';



// WEBPACK FOOTER //
// ./src/constants/storageKeys.js